import { render, staticRenderFns } from "./userAgree.vue?vue&type=template&id=1385296a&scoped=true&"
import script from "./userAgree.vue?vue&type=script&lang=js&"
export * from "./userAgree.vue?vue&type=script&lang=js&"
import style0 from "./userAgree.vue?vue&type=style&index=0&id=1385296a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1385296a",
  null
  
)

export default component.exports